import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import App from '@/entry-points/main/App.vue'
import vuetify from '@/plugins/vuetify';
import '@/permission' // permission control
import '@/plugins/paper'
import { helperMethods } from '@/utils/helpers'

if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false
}

Vue.mixin({
  methods: helperMethods
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
